/* istanbul ignore file */
import React, { ReactNode } from 'react';
import OpportunitiesBreadcrumbs from 'domain/sales/opportunity/shared/OpportunitiesBreadcrumbs';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useShowContext } from 'framework/show';
import { useOpportunityUrl } from 'domain/sales/opportunity/opportunityRouting';

const SingleOpportunityBreadcrumbs = ({ children = null }: { children?: ReactNode | ReactNode[] }) => {
  const { data } = useShowContext();
  const { getSingleEntityUrl } = useOpportunityUrl();
  const opportunityName = data.getValueBySource('name');
  const id = data.getValueBySource('id');
  const singleOpportunityUrl = getSingleEntityUrl(id);

  return (
    <OpportunitiesBreadcrumbs>
      <SingleBreadcrumbItem entity={opportunityName} link={singleOpportunityUrl} />
      {children}
    </OpportunitiesBreadcrumbs>
  );
};

export default SingleOpportunityBreadcrumbs;
